import { Fragment } from "react"
import { useInView } from "react-intersection-observer"

import { Heading, MobileStickyCta } from "@trueskin-web/components"
import { Trans, useTranslation } from "@trueskin-web/translations"

import TermsAndConditions from "../terms-and-conditions"
import TrustedShopsBadge from "../trusted-shops-badge"

import Addresses from "./addresses"
import { Methods } from "./methods"
import Overview from "./overview"

const Payment = ({ repurchase, title = "", description }) => {
  const { t } = useTranslation()

  const [inViewRef, isInView, inViewEl] = useInView({
    threshold: 0,
  })

  return (
    <Fragment>
      <div
        data-testid="web-portal-summary-payment"
        sx={{
          display: "grid",
          gridTemplateColumns: ["auto", "5fr 6fr"],
          columnGap: [null, 10],
          rowGap: [null, 5],
          mt: 5,
        }}
      >
        <Heading size="lg" sx={{ display: ["none", "block"] }}>
          {title}
        </Heading>

        <div />

        <div
          sx={{
            order: [1, "initial"],
          }}
        >
          {description && (
            <div
              sx={{
                display: ["none", "block"],
              }}
            >
              {description}
            </div>
          )}

          <Addresses
            repurchase={repurchase}
            sx={{
              mt: [7, description ? 7 : 0],
            }}
          />
        </div>

        <div>
          <Heading
            sx={{
              fontSize: [5, 5],
              fontWeight: [null, null],
              lineHeight: "smallerHeading",
              variant: "vwo.heading",
              mb: 4,
            }}
          >
            <Trans i18nKey="Payment.Overview.title" />
          </Heading>

          <Overview repurchase={repurchase} />

          <Methods ref={inViewRef} />

          <MobileStickyCta
            show={!isInView}
            title={t("Payment.MobileStickyCta.title")}
            onClick={() => {
              window.scrollTo({
                behavior: "smooth",
                top: inViewEl.target.offsetTop - 15,
              })
            }}
          />
        </div>
      </div>
      <TrustedShopsBadge />
      <TermsAndConditions />
    </Fragment>
  )
}

export default Payment
